





import { Component, Vue, Watch } from 'vue-property-decorator'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

@Component
export default class App extends Vue {
  public get layout(): string {
    let layout = 'base'

    // meta.layoutから直接指定
    if (this.$route.meta && this.$route.meta.layout) {
      layout = this.$route.meta.layout
    }

    return layout + '-layout'
  }

  // ページ遷移時処理
  @Watch('$route')
  private pageMoved(): void {
    this.setTitle()
  }

  // ページタイトル設定
  private setTitle(): void {
    document.title = 'ACBT'
  }
}
